export default "__VITE_ASSET__CRZEKYZj__"